import * as React from "react";
const SvgArrowUp = props => <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 12L10 7L15 12" strokeWidth={1.25} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgArrowUp;